// The two contact checks the /live lane shares (D10, owner staging QA
// 2026-09-05: "there is no confirm button for the email/phone # editing on the
// end screen").
//
// WHY THIS EXISTS. Both of these were module-private in JoinCard.tsx, and D10
// gives the end screen's NotifyCard a Save button that has to accept exactly
// what the join form accepts. A second copy in NotifyCard would be a second
// definition of "a valid phone number" that can drift — the notify card would
// come to refuse a number the join form took, with no compile error and no
// test to say so.
//
// PURE ON PURPOSE. No React, no DOM, no imports — the same contract
// chatGrouping.ts and chatChromeHeight.ts hold. The rules below are the only
// interesting logic either caller shares, and keeping them here means they can
// be reasoned about (and tested) without mounting a form.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Loose email check. Deliberately a sanity check and not a carrier-grade
// validator: joining and opting in are meant to be frictionless, and the server
// sanitizes/normalizes on write and is the authority on what it will accept.
export function isValidEmail(raw: string): boolean {
  return EMAIL_RE.test(raw);
}

// Loose US phone check: 10 digits, or 11 digits leading with country code 1.
// Deliberately a sanity check and not a carrier-grade validator, for the same
// reason as isValidEmail above (the server sanitizes/normalizes on write).
export function isLooseUsPhone(raw: string): boolean {
  const digits = raw.replace(/\D/g, "");
  return digits.length === 10 || (digits.length === 11 && digits.startsWith("1"));
}

// Non-empty check for the join form's first/last name fields, which became
// REQUIRED alongside phone and email (owner ruling 2026-09-18, JS3). It lives
// beside the other two because the join form's four required rules are one
// contract, and because the check is not the trivial one it looks like: antd's
// bare `required` rule accepts a string of spaces, and "   " is not a name.
// The notify card asks for no name, so nothing there changes.
export function isProvidedName(raw: string): boolean {
  return raw.trim().length > 0;
}
